/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useState} from 'react';
import {Button, Form, Input, Radio} from "antd";
import {useStore} from "zustand";
import styles from './InsertBaechaBlock.module.scss';
import {useMessageStore} from "../../../../../stores/messageStore";
import {User} from "../../../../../types/User";
import groupAPI from "../../../../../api/groupAPI";
import userAPI from "../../../../../api/userAPI";
import {GroupSelectOption} from "../../../../../components/common/selector/GroupSelect2/GroupSelect2.interface";
import GroupSelect2 from "../../../../../components/common/selector/GroupSelect2/GroupSelect2";
import Constants from "../../../../../constants";
import {useAppStore} from "../../../../../stores/appStore";

const options = [
	{ label: '차단 대상 전화번호', value: 'user' },
	{ label: '차단 대상 배차방', value: 'group' },
]

interface InsertBaechaBlockProps {
	selectedItem: User;
	afterSubmit: () => any;
}

const InsertBaechaBlock = ({ selectedItem, afterSubmit }: InsertBaechaBlockProps) => {
	const { setMessages } = useStore(useMessageStore);
	const setShouldShowSpinner = useAppStore((state) => state.setShouldShowSpinner);
	const [form] = Form.useForm();
	const watchType = Form.useWatch('type', form);
	const watchTargetPhoneNum = Form.useWatch('targetPhoneNum', form);
	const watchTargetGroupId = Form.useWatch('targetGroupId', form);

	const [memberInfo, setMemberInfo] = useState<any[]>([]);
	const [memberId, setMemberId] = useState('');
	const [selectedGroupId, setSelectedGroupId] = useState('');
	const [targetSelectedGroupId, setTargetSelectedGroupId] = useState('');
	const [groupData, setGroupData] = useState<any[]>([]);

	const onFinish = async (values: any) => {
		if (!memberId) {
			setMessages('error', '에러 발생');
			return;
		}

		setShouldShowSpinner(true);
		const { type, targetGroupId, targetPhoneNum, reason } = values;

		const data: any = {
			groupId: selectedGroupId,
			userId: selectedItem.id,
			memberId,
			reason,
		}
		if (type === 'user') {
			data.targetPhoneNum = targetPhoneNum.trim();
		}
		if (type === 'group') {
			data.targetGroupId = targetGroupId.trim();
		}

		try {
			await groupAPI.insertGroupBaechaBlock(data)
			setMessages('success', '차단 등록 완료');
			form.resetFields();
			setSelectedGroupId('');
			setTargetSelectedGroupId('');
			await afterSubmit();
		} catch (e) {
			console.error(e);
		} finally {
			setShouldShowSpinner(false);
		}
	};

	const onFinishFailed = () => {

	};

	const onValuesChange = () => {

	};

	const onSelectGroup = (value: string, option: GroupSelectOption | GroupSelectOption[]) => {
		setSelectedGroupId(value);

		// set memberId
		const targetMember = memberInfo.find((item) => item.groupId === value);
		setMemberId(targetMember?.memberId || '');
	}

	const getBtnDisabled = () => {
		// 어느 방에서 차단
		if (!selectedGroupId) return true;

		// memberId
		if (!memberId) return true;

		// 타입별 필수값
		if (watchType === 'user') {
			if (!watchTargetPhoneNum || !watchTargetPhoneNum.trim()) return true;
		}

		if (watchType === 'group') {
			if (!watchTargetGroupId) return true;
		}

		return false;
	};

	const onClickMobeBtn = () => {
		setSelectedGroupId(Constants.CALL_CENTER_GROUP_ID);
		// set memberId
		const targetMember = memberInfo.find((item) => item.groupId === Constants.CALL_CENTER_GROUP_ID);
		setMemberId(targetMember?.memberId || '');
	};

	useEffect(() => {
		// 유저의 memberInfo 가져오기
		userAPI.fetchUserInfoAPI(selectedItem.id)
			.then((res) => {
				const newMemberInfo = res.memberInfo.filter((item: any) => item.status === 'ok');
				setMemberInfo(newMemberInfo);
			})
			.catch((error) => {
				console.error("Error fetching memberInfo list:", error);
			});
	}, []);

	useEffect(() => {
		// 가입한 배차방 id 목록
		const memberGroupIds = memberInfo.map((item) => item.groupId);
		// 배차방 목록 가져오기: 전체 배차방 가져온 뒤, 가입된 방만 필터링
		groupAPI.fetchGroupList()
			.then((res) => {
				const newGroupData = res.filter((item: any) => memberGroupIds.includes(item.id));
				setGroupData(newGroupData)
			})
			.catch((error) => {
				console.error("Error fetching group list:", error);
			});
	}, [memberInfo]);

	return (
		<div className={styles.wrap}>
			<Form
				form={form}
				initialValues={{
					groupId: selectedGroupId,
					type: options[0].value,
				}}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				onValuesChange={onValuesChange}
				autoComplete="off"
			>
				{/*	조회창 */}
				<div style={{ display: 'flex', gap: '20px' }}>
					<Form.Item
						label="어느 방에서 차단?"
						name="groupId"
					>
						<div style={{ width: '280px'}}>
							<GroupSelect2
								value={selectedGroupId}
								groupData={groupData}
								onSelect={onSelectGroup}
							/>
						</div>
					</Form.Item>
					{groupData.find((item) => item.id === Constants.CALL_CENTER_GROUP_ID) && (
						<div>
							<Button onClick={onClickMobeBtn}>모배 입력</Button>
						</div>
					)}
				</div>

				<div style={{ display: 'flex', gap: '20px' }}>
					{/* 라디오 */}
					<div>
						<Form.Item name="type" style={{ width: '350px' }}>
							<Radio.Group
								block
								options={options}
								optionType="button"
								buttonStyle="solid"
								onChange={() => {
									setTargetSelectedGroupId('');
									form.resetFields(['targetPhoneNum', 'targetGroupId']);
								}}
							/>
						</Form.Item>
					</div>

					{/* 전화번호 혹은 배차방명	*/}
					<div>
						{watchType === 'user' && (
							<Form.Item name="targetPhoneNum">
								<Input />
							</Form.Item>
						)}
						{watchType === 'group' && (
							<Form.Item name="targetGroupId">
								<div style={{ width: '280px'}}>
									<GroupSelect2
										value={targetSelectedGroupId}
										groupData={groupData}
										onSelect={(value, option) => {
											form.setFieldValue('targetGroupId', value);
											setTargetSelectedGroupId(value)
										}}
									/>
								</div>
							</Form.Item>
						)}
					</div>
				</div>

				{/* 사유 */}
				<Form.Item
					label="사유"
					name="reason"
				>
					<Input />
				</Form.Item>

				{/* 차단 등록 버튼 */}
				<Form.Item wrapperCol={{ offset: 8, span: 16 }}>
					<Button type="primary" htmlType="submit" disabled={getBtnDisabled()}>
						차단 등록
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};

export default InsertBaechaBlock;
